module.exports = __webpack_public_path__ + "img/City_Club.fb5bdf4e.png";